import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import testimonial1 from '../../images/testimonial/img-1.jpg'
import testimonial2 from '../../images/testimonial/img-2.jpg'
import testimonial3 from '../../images/testimonial/img-3.jpg'
import Quote from '../../images/testimonial/quote.svg'


const testimonials = [
    {
        id: '01',
        Des: "YV Reddy Associates and her team were very helpful from beginning to end. Extremely creative, professional, and capable of handling all our needs. I strongly recommend using Inside Style for all your interior design needs. Our new home is gorgeous. Thanks, YV Reddy.",
        Title: 'Mr.Madhusudan Naidu ',
        Sub: "Builder",
        image: testimonial1,
    },
    {
        id: '02',
        Des: " I am one of the many satisfied customers who have used yv reddy associates services. YV Reddy recognizes the value of extraordinary service, thrives to maintain that, and shows professional concern for the quality of work performed. It was a pleasure to work with veera reddy on my new home.",
        Title: 'Mr.Jagan Mohan Rao ',
        Sub: "Businessman",
        image: testimonial1,
    },
    {
        id: '03',
        Des: " Highly recommended – I have to say I was a little scared of having an interior designer… but not any more !",
        Title: 'Mr. Ragav',
        Sub: "Client",
        image: testimonial1,
    },
    {
        id: '04',
        Des: " Working with YV Reddy Associates has been a pleasure and a positive experience. The design team went above and beyond their call of duty. We ended up with an environment that is beautiful, functional and very unique.",
        Title: 'Mr.Rajasekhar',
        Sub: "Client",
        image: testimonial1,
    },


]

const Testimonial = (props) => {

    const settings = {
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    dots: true,
                    arrows: false,
                }
            },
        ]
    }


    return (
        <section className={"" + props.hclass}>
            <Slider {...settings} className="testimonial-slider">
                {testimonials.slice(0, 4).map((testimonial, item) => (
                    <div className="item" key={item}>
                        <div className="bg-image">
                            <img src={testimonial.image} alt="testimonial" />
                        </div>
                        <div className="content fade_bottom">
                            <div className="icon">
                                <img src={Quote} alt="quote" />
                            </div>
                            <h3>{testimonial.Des}</h3>
                            <h4>{testimonial.Title}</h4>
                            <span>{testimonial.Sub}</span>
                        </div>
                    </div>
                ))}

            </Slider>
        </section>
    );
}

export default Testimonial;







